import { render, staticRenderFns } from "./WizardAudience.vue?vue&type=template&id=4dc33244&"
import script from "./WizardAudience.vue?vue&type=script&lang=js&"
export * from "./WizardAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports